document.addEventListener('DOMContentLoaded', function() {
  console.log('🛍️ Initializing product recommended carousel...');
  
  const container = document.getElementById('product-recommended-carousel');
  if (!container) {
    console.log('🛍️ Product recommended carousel container not found');
    return;
  }
  
  console.log('🛍️ Container found:', container);
  console.log('🛍️ Container HTML:', container.innerHTML.substring(0, 200));

  const items = Array.from(container.children);
  if (items.length === 0) {
    console.log('🛍️ No items found in carousel');
    return;
  }
  
  if (items.length <= 3) {
    console.log('🛍️ Not enough items for carousel, showing as static grid');
    container.style.display = 'grid';
    container.style.gridTemplateColumns = 'repeat(auto-fit, minmax(300px, 1fr))';
    container.style.gap = '1rem';
    container.style.visibility = 'visible';
    return;
  }

  // Transform into carousel
  container.classList.add('carousel-container');

  const track = document.createElement('div');
  track.className = 'carousel-track';

  // Get responsive items per view and slide width percentage
  function getItemsPerView() {
    const width = window.innerWidth;
    if (width <= 768) return 1;   // 1 item on mobile
    if (width <= 1024) return 2;  // 2 items on tablet
    return 3; // Move by 3 items at a time on desktop (even though 3.33 are visible)
  }

  function getSlideWidthPercent() {
    const width = window.innerWidth;
    if (width <= 768) return 100;   // 100% width on mobile (1 item)
    if (width <= 1024) return 50;    // 50% width on tablet (2 items)
    return 30; // 30% width on desktop (~3.33 items visible)
  }

  let currentIndex = 0;
  let itemsPerView = getItemsPerView();

  // Create slides
  items.forEach(item => {
    const slide = document.createElement('div');
    slide.className = 'carousel-slide';
    slide.appendChild(item);
    track.appendChild(slide);
  });

  container.innerHTML = '';
  container.appendChild(track);

  // Add navigation arrows
  const prevBtn = document.querySelector('.product-carousel-container button.carousel-arrow.carousel-prev');
  const nextBtn = document.querySelector('.product-carousel-container button.carousel-arrow.carousel-next');

  function updateCarousel() {
    // Calculate slide width percentage based on screen size
    const slideWidthPercent = getSlideWidthPercent();
    const translateX = -currentIndex * slideWidthPercent;
    track.style.transform = `translateX(${translateX}%)`;

    // Update button states
    prevBtn.disabled = currentIndex === 0;
    nextBtn.disabled = currentIndex >= items.length - itemsPerView;
    
    prevBtn.style.opacity = prevBtn.disabled ? '0.5' : '1';
    nextBtn.style.opacity = nextBtn.disabled ? '0.5' : '1';
  }

  function nextSlide() {
    if (currentIndex < items.length - itemsPerView) {
      currentIndex++;
      updateCarousel();
    }
  }

  function prevSlide() {
    if (currentIndex > 0) {
      currentIndex--;
      updateCarousel();
    }
  }

  // Event listeners
  nextBtn.addEventListener('click', (e) => {
    e.preventDefault();
    nextSlide();
  });

  prevBtn.addEventListener('click', (e) => {
    e.preventDefault();
    prevSlide();
  });

  // Handle window resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const newItemsPerView = getItemsPerView();
      if (newItemsPerView !== itemsPerView) {
        itemsPerView = newItemsPerView;
        // Adjust current index if needed when breakpoint changes
        if (currentIndex > items.length - itemsPerView) {
          currentIndex = Math.max(0, items.length - itemsPerView);
        }
        updateCarousel();
      } else {
        // Even if itemsPerView hasn't changed, update carousel to recalculate slide width
        updateCarousel();
      }
    }, 250);
  });

  // Touch/swipe support
  let startX = 0;
  let isDragging = false;
  
  track.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    isDragging = true;
  });

  track.addEventListener('touchmove', (e) => {
    if (!isDragging) return;
    e.preventDefault();
  });

  track.addEventListener('touchend', (e) => {
    if (!isDragging) return;
    isDragging = false;
    const endX = e.changedTouches[0].clientX;
    const diff = startX - endX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) nextSlide();
      else prevSlide();
    }
  });

  // Initialize
  updateCarousel();
  
  console.log('🛍️ Product recommended carousel initialized with', items.length, 'items');
});
